import React from "react";
import DarkNavbar from "./components/DarkNavbar";
import Hero from "./components/Hero";
import Presence from "./components/Presence";
import Services from "./components/Services";
import LaunchSection from "./components/LaunchSection";
import APISection from "./components/APISection";
import TopTrending from "./components/TopTrending";
import AboutSection from "./components/AboutSection";
import Partners from "./components/Partners";
import ContactSection from "./components/ContactSection";

function App() {
  return (
    <>
      <DarkNavbar />
      <Hero />
      <Presence />
      <Services />
      <LaunchSection />
      <APISection />
      <TopTrending />
      <AboutSection />
      <Partners />
      <ContactSection />
    </>
  );
}

export default App;
